const ScienceDayTemplate = 92391
const BIOTemplate = 67469

const ProjectTemplates = [ScienceDayTemplate, BIOTemplate]

export default {
  data: function () {
    return {
      ScienceDayTemplate,
      BIOTemplate,
      ProjectTemplates
    }
  }
}
